import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Route} from '../../utils/constant';
import {Router} from '@angular/router';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {TitleCasePipe} from '@angular/common';
import {DataService} from '../../services/data.service';
import {FormService} from '../../services/form.service';
import {ServerResponse} from '../../models/server-response.model';
import swal from 'sweetalert';
import {isObject} from 'util';
import {MatTableDataSource} from '@angular/material';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-typography',
  templateUrl: './typography.component.html',
  styleUrls: ['./typography.component.css']
})
export class TypographyComponent implements OnInit { // tutorialUrlText: string;
  _formErrors: any = {};
  form: FormGroup;
  termsData = {
    termsText: ''
  };

  constructor(private titlecase: TitleCasePipe,public user: UserService, private router: Router, private dataService: DataService, private formService: FormService) {
  }

  ngOnInit() {
    if(this.user.getRole())
    {
      this.router.navigate(['/' + Route.organizations])
    }
    else{
    this.dataService.getTermsAndConditions().subscribe((data: ServerResponse) => {
      if (!data) {
        return;
      }
        this.termsData.termsText = data.data.text;

      });
    this._resetFormErrors();
    this.form = new FormGroup({
      termsText: new FormControl(null, [Validators.required])
    });
  }
  }
  private _resetFormErrors(): void {
    for (const credentialKey in this.termsData) {
      if (this.termsData.hasOwnProperty(credentialKey)) {
        this._formErrors[credentialKey] = {valid: true, message: ''};
      }
    }
  }

  formReset() {
    this.router.navigate(['/' + Route.default]);
  }

  putTermsAndConditions() {
    if (!this.form.invalid) {
      this.dataService.putTermsAndConditions({text: this.termsData.termsText}).subscribe((response: ServerResponse) => {
          console.log('response', response);
          if (response.error === 0 && response.authError === 0) {
            swal({
              title: 'Message',
              text: 'Terms and Conditions are Updated Successfully',
              icon: 'success'
            });
            this.router.navigate(['/' + Route.default]).catch(reason => {
              console.log('reason', reason);
            });
          } else if (response.error > 0) {
            if (isObject(response.msg)) {
              for (const msgKey in response.msg) {
                if (response.msg.hasOwnProperty(msgKey)) {
                  this.form.get(msgKey).setErrors({server: true, msg: response.msg[msgKey][0]});
                }
              }
            } else {
              this.form.get('termsText').setErrors({server: true, msg: response.msg});
            }
          }
        },
        error => {
          console.log('error message ', error.message);
        });
    } else {
      this.formService.validateAllFormFields(this.form);
      return false;
    }
  }

  hasError(field): boolean {
    if (this.form.get(field).invalid && this.form.get(field).touched) {
      let msg = '';
      if (this.form.get(field).errors.required) {
        // msg = this.titlecase.transform(field.replace('_', ' ')) + ' cannot be blank.';
        msg = 'Term text cannot be blank.';
      }
      this._formErrors[field] = {valid: false, message: msg};
    } else {
      this._formErrors[field] = {valid: true, message: ''};
    }
    return !this._formErrors[field].valid;
  }
}
